var _defs, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompareExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 125 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h1792v1080h-1792z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.ce_s0 { fill: none;stroke: #533ffb;stroke-miterlimit:100;stroke-width: 2 }\n\t\t.ce_s1 { fill: #533ffb } \n\t\t.ce_s2 { fill: #4caf50 } \n\t\t.ce_s3 { fill: #ffffff } \n\t\t.ce_s4 { fill: #2e7d32 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-workspace-task-compare-excel",
    clipPath: "url(#cp1)",
    transform: "translate(-410 -557)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 7779"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 12312"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 13189",
    className: "ce_s0",
    d: "m473.8 579.3h-9.3m13.9 0h-2.3m7 0h-2.4m-9.2-11.6h9.2m-13.9 0h2.4m-7 0h2.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 13190",
    fillRule: "evenodd",
    className: "ce_s1",
    d: "m484.2 567.7l-5.8 5.8v-11.6zm-17.4 5.8v11.6l-5.8-5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 13191",
    className: "ce_s2",
    d: "m446.7 561.1h-16.8v29.4h16.8c0.6 0 1.1-0.5 1.1-1v-27.3c0-0.6-0.5-1.1-1.1-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 13192",
    className: "ce_s3",
    d: "m437.3 566.4h7.3v3.1h-7.3zm0 10.5h7.3v3.2h-7.3zm0 5.2h7.3v3.2h-7.3zm0-10.5h7.3v3.1h-7.3zm-7.4-5.2h5.3v3.1h-5.3zm0 10.5h5.3v3.2h-5.3zm0 5.2h5.3v3.2h-5.3zm0-10.5h5.3v3.1h-5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 13193",
    className: "ce_s4",
    d: "m432 594.7l-22-4.2v-29.4l22-4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 13194",
    className: "ce_s3",
    d: "m423.8 583.2l-2.6-4.8q-0.1-0.3-0.3-1-0.1 0.3-0.3 1l-2.6 4.8h-3.9l4.7-7.4-4.3-7.3h4l2.1 4.4q0.3 0.5 0.5 1.2 0.1-0.4 0.5-1.3l2.3-4.3h3.7l-4.4 7.3 4.5 7.4h-3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 13195",
    className: "ce_s2",
    d: "m533.7 561.1h-16.8v29.4h16.8c0.6 0 1.1-0.5 1.1-1v-27.3c0-0.6-0.5-1.1-1.1-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 13196",
    className: "ce_s3",
    d: "m524.3 566.4h7.3v3.1h-7.3zm0 10.5h7.3v3.2h-7.3zm0 5.2h7.3v3.2h-7.3zm0-10.5h7.3v3.1h-7.3zm-7.4-5.2h5.3v3.1h-5.3zm0 10.5h5.3v3.2h-5.3zm0 5.2h5.3v3.2h-5.3zm0-10.5h5.3v3.1h-5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 13197",
    className: "ce_s4",
    d: "m519 594.7l-22-4.2v-29.4l22-4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 13198",
    className: "ce_s3",
    d: "m510.8 583.2l-2.6-4.8q-0.1-0.3-0.3-1-0.1 0.3-0.3 1l-2.6 4.8h-3.9l4.7-7.4-4.3-7.3h4l2.1 4.4q0.2 0.5 0.4 1.2h0.1q0.1-0.4 0.4-1.3l2.4-4.3h3.7l-4.4 7.3 4.5 7.4h-3.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareExcel);
export default __webpack_public_path__ + "static/media/compare-excel.48ab6499306d1a0a79ee6eeba433c243.svg";
export { ForwardRef as ReactComponent };